import React from 'react';
import {
  TableContainer,
  TableHead,
  TableBody,
  TableBodyRow,
  TableHeadCell,
} from '../../../../components/tableComponents';

export const tableComponents = {
  table: TableContainer,
  header: {
    wrapper: TableHead,
    cell: TableHeadCell,
  },
  body: {
    wrapper: TableBody,
    row: ({ expanded, ...props }) => (
      <TableBodyRow
        {...props}
        isExpanded={expanded}
        isClickable
      />
    ),
  },
};
